module.exports = __webpack_public_path__ + "img/reward-icon.68732241.png";